export default "__VITE_ASSET__CVRzWbN1__"